import React, { Component }  from 'react';
import { ConnectConstants }  from './environment';
import { isInRoleFromToken } from '../../../utils/authService';

class ConnectBreadcrumb extends Component {

  render() {
    console.log('ConnectConstants.AdminRole: ' + ConnectConstants.AdminRole);
    if (isInRoleFromToken(ConnectConstants.AdminRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={ConnectConstants.AdminHashPrefix} className="anchor c-breadcrumbs__anchor" >
                Representatives
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={ConnectConstants.AdminHashPrefix + '/settings'} className="anchor c-breadcrumbs__anchor" >
                Settings
              </a>
            </li>
            <li className="c-breadcrumbs__item">
              <a href={ConnectConstants.UserHashPrefix} className="anchor c-breadcrumbs__anchor" >
                Chat
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (ConnectConstants.UserRole === "*" || isInRoleFromToken(ConnectConstants.UserRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={ConnectConstants.UserHashPrefix} className="anchor c-breadcrumbs__anchor" >
                Chat
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default ConnectBreadcrumb;